document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header-container");
  const masthead = document.getElementById("masthead");

  /* ── adaptive header tone ──
     The bar is fully transparent (partials/_global.scss), so legibility comes
     from matching the text to whatever the page shows behind the bar: resolve
     the effective background of the element under it — an explicit
     data-header-tone="dark|light" attribute wins, then the first
     non-transparent background-color (by luminance), and hero imagery
     (img/video/background-image) counts as dark. Toggles .header-tone-light
     (white text/logo) on the <header>; default is dark text. */
  function effectiveTone(start) {
    let el = start;
    while (el && el !== document.documentElement) {
      if (el.dataset && el.dataset.headerTone) return el.dataset.headerTone;
      const cs = window.getComputedStyle(el);
      const m = (cs.backgroundColor || "").match(/rgba?\(([^)]+)\)/);
      if (m) {
        const p = m[1].split(",").map(parseFloat);
        const alpha = p.length > 3 ? p[3] : 1;
        if (alpha >= 0.4) {
          const lum = (0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]) / 255;
          return lum < 0.55 ? "dark" : "light";
        }
      }
      if (
        el.tagName === "IMG" ||
        el.tagName === "VIDEO" ||
        (cs.backgroundImage && cs.backgroundImage !== "none")
      ) {
        return "dark"; // hero imagery: keep the nav white over photos
      }
      el = el.parentElement;
    }
    return "light";
  }

  function updateHeaderTone() {
    // The bar is now solid white site-wide, so the adaptive white-text tone
    // (.header-tone-light) would be invisible — keep the header in its default
    // dark-text state everywhere. effectiveTone() is retained above in case the
    // transparent/adaptive bar is ever brought back.
    if (masthead) masthead.classList.remove("header-tone-light");
  }

  // Publish the real bar height so content can be offset by exactly the right
  // amount (CSS ships an 88px desktop fallback for first paint / no-JS).
  function setHeaderOffset() {
    if (!masthead) return;
    document.documentElement.style.setProperty(
      "--pe-header-h",
      masthead.offsetHeight + "px"
    );
  }

  // Hide-on-scroll-down / show-on-scroll-up. Direction comes from the user's
  // INPUT (wheel / touch), not from comparing scroll positions: the home page
  // scroll-snaps section by section, and a snap animation's final settle often
  // reads as a tiny upward move — position-based detection re-showed the bar
  // after every snap, leaving it permanently visible. Input-based direction is
  // immune to that, and it also works inside the turn section, whose stepper
  // captures wheel events so no scroll events fire there at all.
  function driveHeader(goingDown) {
    if (!masthead) return;
    // hide only when heading down AND past the bar's own height; always
    // reveal on the way up, and never hide with the mobile menu open (its
    // panel lives inside the bar).
    const menuOpen = !!document.querySelector(".toggle-icon.active");
    const pastBar = window.scrollY > masthead.offsetHeight;
    masthead.classList.toggle(
      "header-hidden",
      goingDown && pastBar && !menuOpen
    );
  }
  window.addEventListener(
    "wheel",
    function (e) {
      if (e.deltaY) driveHeader(e.deltaY > 0);
    },
    { passive: true }
  );
  let headerTouchY = null;
  window.addEventListener(
    "touchstart",
    function (e) {
      headerTouchY = e.touches[0].clientY;
    },
    { passive: true }
  );
  window.addEventListener(
    "touchmove",
    function (e) {
      if (headerTouchY === null) return;
      const dy = headerTouchY - e.touches[0].clientY; // >0 = swiping up = heading down
      if (Math.abs(dy) > 6) {
        driveHeader(dy > 0);
        headerTouchY = e.touches[0].clientY;
      }
    },
    { passive: true }
  );

  function updateHeader() {
    const y = window.scrollY;
    const isScroll = y > 50;
    if (header) {
      header.classList.toggle("header-on-scroll", isScroll);
      header.classList.toggle("header-mobile-bg", isScroll);
    }
    // near the top the bar is always shown, whatever the last gesture was
    if (masthead && y <= masthead.offsetHeight) {
      masthead.classList.remove("header-hidden");
    }
    updateHeaderTone();
  }

  // Run on scroll, rAF-throttled
  let headerRaf = 0;
  window.addEventListener("scroll", function () {
    if (headerRaf) return;
    headerRaf = requestAnimationFrame(function () {
      headerRaf = 0;
      updateHeader();
    });
  });

  // Run on resize to handle screen size changes
  window.addEventListener("resize", function () {
    setHeaderOffset();
    updateHeader();
  });
  window.addEventListener("load", setHeaderOffset);

  // Initial check when the page loads
  setHeaderOffset();
  updateHeader();
});

// Who-we-are hero: smooth-scroll the "Meet the leadership team" button down to
// the Our People section. scroll-margin-top on the target (set in CSS to the
// header height) keeps the heading clear of the fixed header. Scoped: the
// listener only attaches when the hero link is on the page.
(function () {
  const heroLink = document.querySelector(".wwa-hero-link");
  if (!heroLink) return;
  heroLink.addEventListener("click", function (e) {
    const target = document.getElementById("our-people-section");
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
})();

// header hover effect
(function () {
  const target = document.querySelector(".target");
  const links = document.querySelectorAll(".mynav a");

  function mouseenterFunc() {
    const parentItem = this.parentNode;

    // If hovering over a submenu item, keep the target on its parent
    if (parentItem.closest(".sub-menu")) {
      const parentMenuItem = parentItem.closest(".menu-item-has-children");
      if (parentMenuItem) {
        target.style.width = `${parentMenuItem.offsetWidth}px`;
        target.style.left = `${parentMenuItem.offsetLeft}px`;
      }
      return;
    }

    // Remove active class from all
    links.forEach((link) => link.parentNode.classList.remove("active"));

    // Set active class on the current item
    parentItem.classList.add("active");

    target.style.width = `${parentItem.offsetWidth}px`;
    target.style.left = `${parentItem.offsetLeft}px`;
    target.style.transform = "none";
  }

  links.forEach((link) => link.addEventListener("mouseenter", mouseenterFunc));

  function resizeFunc() {
    const active = document.querySelector(".mynav li.active");
    if (active) {
      target.style.left = `${active.offsetLeft}px`;
    }
  }

  window.addEventListener("resize", resizeFunc);
})();

// header toggle mobile
document.addEventListener("DOMContentLoaded", function () {
  const menuContainer = document.querySelector("header .header-menu-container");
  const headerBtnContainer = document.querySelector(
    "header .header-button-container"
  );
  const headerContainer = document.querySelector("header .header-container");
  const toggleButton = document.querySelector(".toggle-icon");
  const body = document.body;

  toggleButton.addEventListener("click", function () {
    menuContainer.classList.toggle("show");
    menuContainer.classList.toggle("hidden");

    headerBtnContainer.classList.toggle("show");
    headerBtnContainer.classList.toggle("hidden");

    toggleButton.classList.toggle("active");

    if (toggleButton.classList.contains("active")) {
      body.style.overflow = "hidden";
      headerContainer.style.height = "100vh";
      document.querySelector(".header-logo-container").style.backgroundColor =
        "#F3F2ED";

      // Change toggle icon span background color
      document
        .querySelectorAll(
          ".page-template-template-contact-us header .header-container .header-logo-container .header-logo-container-main .toggle-icon span, .page-template-template-home header .header-container .header-logo-container .toggle-icon span"
        )
        .forEach((span) => {
          span.style.backgroundColor = "#000"; // Set to black
        });

      document
        .querySelectorAll(
          ".page-template-template-contact-us .header-logo-container-main svg g .logo-letter, .page-template-template-home .header-logo-container-main svg g .logo-letter"
        )
        .forEach((logoLetter) => {
          logoLetter.style.fill = "#2a848b";
        });
    } else {
      body.style.overflow = "";
      headerContainer.style.height = "";
      document.querySelector(".header-logo-container").style.backgroundColor =
        "";

      // Reset toggle icon span background color
      document
        .querySelectorAll(
          ".page-template-template-contact-us header .header-container .header-logo-container .header-logo-container-main .toggle-icon span, .page-template-template-home header .header-container .header-logo-container .header-logo-container-main .toggle-icon span"
        )
        .forEach((span) => {
          span.style.backgroundColor = ""; // Reset to default
        });

      document
        .querySelectorAll(
          ".page-template-template-contact-us .header-logo-container-main svg g .logo-letter, .page-template-template-home .header-logo-container-main svg g .logo-letter"
        )
        .forEach((logoLetter) => {
          logoLetter.style.fill = ""; // hand the fill back to the tone system
        });
      // re-evaluate the header tone now that the panel is gone
      window.dispatchEvent(new Event("scroll"));
    }
  });
});

// ----- Homepage -----

// // Hero banner slider

document.addEventListener("DOMContentLoaded", function () {
if (document.querySelector(".hero-banner")) {
  var listArray = [];

  document
    .querySelectorAll(".hero-banner .swiper-slide-home-banner")
    .forEach((slide) => {
      let text = slide.querySelector(".empty-tag-for-loader")?.innerText || "";
      listArray.push(text);
    });

  function initSwiper() {
    var swiper = new Swiper(".hero-banner .swiper-container", {
      loop: true,
      effect: "slide",
      parallax: true,
      speed: window.innerWidth <= 768 ? 3000 : 1800,
      autoplay:
        window.innerWidth <= 768
          ? {
              delay: 0,
              disableOnInteraction: false,
            }
          : {
              // desktop: keep total time (transition + delay)
              // close to 3s so it matches the pagination bar
              delay: 1200,
              disableOnInteraction: false,
            },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "bullets",
        renderBullet: function (index, className) {
          return (
            '<span class="col bullet-span ' +
            className +
            '">' +
            "<em>" +
            (listArray[index] || "") +
            "</em>" +
            "<i></i>" +
            "<b></b>" +
            "</span>"
          );
        },
      },
      on: {
        slideChangeTransitionStart: function () {
          let progressBar = document.querySelector(".swiper-progress-bar span");
          if (progressBar) {
            progressBar.style.transition = "none";
            progressBar.style.width = "0%";
            setTimeout(() => {
              progressBar.style.transition = `width ${swiper.params.speed}ms linear`;
              progressBar.style.width = "100%";
            }, 50);
          }
        },
      },
    });

    return swiper;
  }

  var heroBannerSwiper = initSwiper();

  // Attach to all controls (original + cloned slides)
  var playPauseButtons = document.querySelectorAll(".hero-banner-play-pause");
  if (heroBannerSwiper && playPauseButtons.length) {
    playPauseButtons.forEach(function (btn) {
      var isPlaying = true;

      btn.addEventListener("click", function () {
        if (isPlaying) {
          if (heroBannerSwiper.autoplay) {
            heroBannerSwiper.autoplay.stop();
          }
          btn.classList.add("is-paused");
          btn.setAttribute("aria-pressed", "true");
        } else {
          // Resume autoplay with the configured delay so it stays
          // in sync with pagination/progress timing.
          if (heroBannerSwiper.autoplay) {
            heroBannerSwiper.autoplay.start();
          }
          btn.classList.remove("is-paused");
          btn.setAttribute("aria-pressed", "false");
        }

        isPlaying = !isPlaying;
      });
    });
  }

  var prevArrows = document.querySelectorAll(".hero-banner-arrow.hero-prev");
  var nextArrows = document.querySelectorAll(".hero-banner-arrow.hero-next");

  if (heroBannerSwiper && prevArrows.length) {
    prevArrows.forEach(function (arrow) {
      arrow.addEventListener("click", function () {
        heroBannerSwiper.slidePrev();
      });
    });
  }

  if (heroBannerSwiper && nextArrows.length) {
    nextArrows.forEach(function (arrow) {
      arrow.addEventListener("click", function () {
        heroBannerSwiper.slideNext();
      });
    });
  }
}
});

// Homepage Question section
// select button
if (document.querySelector(".select-btn")) {
  document.querySelector(".select-btn").addEventListener("click", function () {
    this.classList.toggle("active");
  });
}

// Question section
if (document.querySelector(".select-btn")) {
}
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".industry-belong-sec")) {
    const optionButtons = document.querySelectorAll(".option-btn");
    const mainQuestion = document.querySelector(
      ".Question-container > .heading-2"
    );
    const optionsMain = document.querySelector(".options.optioins-main");

    let selectedIndustry = "";
    let selectedBusinessNeed = "";
    let answeredQuestions = 0; // Track how many questions have been answered

    const progressBar = document.getElementById("progress-bar");
    const progressText = document.getElementById("progress-text");

    // Initially hide the final-answer container
    const finalAnswerContainer = document.querySelector(
      ".final-answer-container-wrap"
    );
    if (finalAnswerContainer) {
      finalAnswerContainer.style.display = "none";
    }

    optionButtons.forEach((btn) => {
      btn.addEventListener("click", function () {
        // Hide the main question
        mainQuestion.style.display = "none";

        // Hide the main options container
        if (optionsMain) {
          optionsMain.style.display = "none";
        }

        // Hide all sub-questions
        document.querySelectorAll(".sub-question").forEach((sub) => {
          sub.style.display = "none";
        });

        // Show the related sub-question
        const optionId = this.classList[2]; // Get the class name
        const relatedSubQuestion = document.getElementById(optionId);
        if (relatedSubQuestion) {
          relatedSubQuestion.style.display = "block";
        }

        // Set selected industry
        selectedIndustry = this.querySelector(".option-text").textContent;

        // Update the progress bar
        answeredQuestions = 1; // Mark first question as answered
        updateProgress();

        // Show the final output when a sub-question is selected
        const subOptionButtons =
          relatedSubQuestion.querySelectorAll(".select-btn");
        subOptionButtons.forEach((subBtn) => {
          subBtn.addEventListener("click", function () {
            selectedBusinessNeed =
              subBtn.querySelector(".option-text").textContent;

            // Display the selected options in the final answer section
            const industrySpan = document.getElementById("option-one");
            const businessNeedSpan = document.querySelector(".option-two");

            if (industrySpan && businessNeedSpan) {
              industrySpan.textContent = selectedIndustry;
              businessNeedSpan.textContent = selectedBusinessNeed;
            }

            // Update progress to show 2/2 when both questions are answered
            answeredQuestions = 2;
            updateProgress();

            // Show the final-answer container
            if (finalAnswerContainer) {
              finalAnswerContainer.style.display = "block";
            }

            // Optionally, reset the selection and hide all options again after showing the final answer
            mainQuestion.style.display = "block";
            optionsMain.style.display = "block";
            document.querySelectorAll(".sub-question").forEach((sub) => {
              sub.style.display = "none";
            });

            // Hide the Question-container and add the 'Question-container-hide' class
            const questionContainer = document.querySelector(
              ".Question-container"
            );
            if (questionContainer) {
              questionContainer.classList.add("Question-container-hide");
            }
          });
        });
      });
    });

    function updateProgress() {
      // Calculate the percentage based on answered questions
      const progress = (answeredQuestions / 2) * 100;
      progressBar.style.width = progress + "%";
      progressText.textContent = `${answeredQuestions}/2`;
    }
  }
});

// Testimonal slider
document.addEventListener("DOMContentLoaded", function () {
  var swiperElement = document.querySelector(".myTestimonalSwiper");
  if (swiperElement) {
    var swiper = new Swiper(".myTestimonalSwiper", {
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
});

// Marquee slider
document.addEventListener("DOMContentLoaded", function () {
  var swiperElement = document.querySelector(".myMarqueeSwiper");
  if (swiperElement) {
    var swiper = new Swiper(".myMarqueeSwiper", {
      spaceBetween: 0,
      centeredSlides: true,
      speed: 2000,
      autoplay: {
        delay: 0,
      },
      loop: true,
      slidesPerView: "auto",
      allowTouchMove: false,
      disableOnInteraction: true,
    });
  }
});

// GSAP Animation are comes below
// Drop animation with GSAP
document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  const dropAnimationSection = document.querySelector(".drop-animation-section");

  if (dropAnimationSection && document.querySelector(".animation")) {
    const circles = document.querySelectorAll(".circle");
    gsap.set(circles, { scale: 1, opacity: 0, transformOrigin: "center center" });

    const tlRepeat = gsap.timeline({
      repeat: -1,
      scrollTrigger: {
        trigger: ".drop-animation-section",
        start: "top 95%",
      },
    });

    gsap.matchMedia().add("(max-width: 768px)", () => {
      tlRepeat
        .to(circles, {
          duration: 1,
          scale: 4.5,
          opacity: 1,
          stagger: 0.15,
          ease: "power2.out",
        })
        .to(circles, {
          duration: 0.7,
          opacity: 0,
          ease: "power2.inOut",
          stagger: 0.15,
        });
    });

    gsap.matchMedia().add("(min-width: 769px)", () => {
      tlRepeat
        .to(circles, {
          duration: 0.5,
          scale: 1.7,
          opacity: 1,
          stagger: 0.15,
          ease: "power2.out",
        })
        .to(circles, {
          duration: 0.5,
          opacity: 0,
          ease: "power2.inOut",
          stagger: 0.15,
        });
    });
  }
});

// // Cards animation with GSAP
// document.addEventListener("DOMContentLoaded", function () {
//   gsap.registerPlugin(ScrollTrigger);

//   const cardOne = document.querySelector(".card-one");
//   const cardOneElements = document.querySelectorAll(
//     ".card-1-content-container-wrap, .card-one-img-container"
//   );
//   const cardTwo = document.querySelector(".card-two-container-gsap");
//   const cardTwoElements = document.querySelectorAll(
//     ".card-two-img-container, .card-2-content-container-wrap"
//   );

//   if (window.innerWidth > 991) {
//     let tlCardone = gsap.timeline({
//       scrollTrigger: {
//         trigger: cardOne,
//         start: "top 20%",
//         pin: true,
//         scrub: 5,
//       },
//     });

//     tlCardone.to(
//       cardOneElements,
//       {
//         opacity: 0,
//         y: -100,
//         ease: "power2.out",
//       },
//       "+=1"
//     );

//     gsap.fromTo(
//       cardOne,
//       { scale: 0.6 },
//       {
//         scale: 1,
//         ease: "power2.inOut",
//         scrollTrigger: {
//           trigger: cardOne,
//           start: "top bottom",
//           end: "top 20%",
//           scrub: true,
//         },
//       }
//     );

//     gsap.to(cardOne, {
//       scrollTrigger: {
//         trigger: cardOne,
//         start: "top 20%",
//         pin: true,
//         scrub: true,
//       },
//       scale: 0.9,
//       ease: "power2.inOut",
//     });

//     gsap.fromTo(
//       cardTwo,
//       { scale: 0.6, y: -600 },
//       {
//         scrollTrigger: {
//           trigger: cardTwo,
//           start: "top bottom",
//           end: "top 20%",
//           scrub: true,
//         },
//         scale: 1,
//         ease: "power2.inOut",
//       }
//     );
//   }

//   // card two hand animation
//   let mm = gsap.matchMedia();
//   mm.add("(max-width: 991px)", () => {
//     let tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: ".card-two-container-gsap",
//         start: "top center",
//         toggleActions: "play none none none",
//       },
//     });
//     animateHands(tl);
//   });

//   mm.add("(min-width: 769px)", () => {
//     let tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: ".card-two-container-gsap",
//         start: "center center",
//         toggleActions: "play none none none",
//       },
//     });
//     animateHands(tl);
//   });

//   mm.add("(min-width: 991px) and (max-width: 1199px)", () => {
//     let tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: ".card-two-container-gsap",
//         start: "top center",
//         toggleActions: "play none none none",
//       },
//     });
//     animateHands(tl);
//   });

//   function animateHands(tl) {
//     tl.to(".hand-one", {
//       opacity: 1,
//       top: 0,
//       left: "50%",
//       duration: 0.6,
//       ease: "power2.out",
//     })
//       .to(
//         ".hand-two",
//         {
//           opacity: 1,
//           top: 0,
//           left: 0,
//           duration: 0.6,
//           ease: "power2.out",
//         },
//         "-=0.3"
//       )
//       .to(
//         ".hand-three",
//         {
//           opacity: 1,
//           top: "50%",
//           right: 0,
//           transform: "translateY(-50%)",
//           duration: 0.6,
//           ease: "power2.out",
//         },
//         "-=0.3"
//       )
//       .to(
//         ".hand-four",
//         {
//           opacity: 1,
//           top: 0,
//           right: 0,
//           duration: 0.6,
//           ease: "power2.out",
//         },
//         "-=0.3"
//       )
//       .to(
//         ".hand-five",
//         {
//           opacity: 1,
//           bottom: 0,
//           right: 0,
//           duration: 0.6,
//           ease: "power2.out",
//         },
//         "-=0.3"
//       )
//       .to(
//         ".hand-six",
//         {
//           opacity: 1,
//           bottom: 0,
//           left: "50%",
//           transform: "translateX(-50%)",
//           duration: 0.6,
//           ease: "power2.out",
//         },
//         "-=0.3"
//       )
//       .to(
//         ".hand-seven",
//         {
//           opacity: 1,
//           bottom: "60px",
//           left: 0,
//           duration: 0.6,
//           ease: "power2.out",
//         },
//         "-=0.3"
//       );
//   }
// });

var mySwiper = new Swiper(".swiper-coverflow", {
  loop: true,
  slidesPerView: "auto",
  centeredSlides: true,
  effect: "coverflow",
  navigation: {
    nextEl: ".swiper-button-next-coverflow",
    prevEl: ".swiper-button-prev-coverflow",
  },
  speed: 800,
  allowTouchMove: false,
  autoplay: {
    delay: 5000,
    reverseDirection: true,
  },
  breakpoints: {
    320: {
      coverflowEffect: {
        rotate: 0,
        stretch: 190,
        depth: 100,
        modifier: 2,
        slideShadows: false,
      },
    },
    390: {
      coverflowEffect: {
        rotate: 0,
        stretch: 218,
        depth: 100,
        modifier: 2,
        slideShadows: false,
      },
    },
    500: {
      // Mobile medium
      coverflowEffect: {
        rotate: 0,
        stretch: 280,
        depth: 100,
        modifier: 2,
        slideShadows: false,
      },
    },
    768: {
      coverflowEffect: {
        rotate: 0,
        stretch: 170,
        depth: 100,
        modifier: 4,
        slideShadows: false,
      },
    },
    800: {
      coverflowEffect: {
        rotate: 0,
        stretch: 180,
        depth: 100,
        modifier: 4,
        slideShadows: false,
      },
    },
    910: {
      coverflowEffect: {
        rotate: 0,
        stretch: 190,
        depth: 100,
        modifier: 4,
        slideShadows: false,
      },
    },
    910: {
      coverflowEffect: {
        rotate: 0,
        stretch: 200,
        depth: 100,
        modifier: 4,
        slideShadows: false,
      },
    },
    1410: {
      coverflowEffect: {
        rotate: 0,
        stretch: 237,
        depth: 100,
        modifier: 4,
        slideShadows: false,
      },
    },
  },
});

const coverflowCards = document.querySelectorAll(
  ".slide-card-wrap-new .swiper-slide-coverflow .swiper-slide-coverflow .slide-card"
);

// Define colors as array
const colors = ["#F3F2ED", "#4AB8BF", "#fff", "#F86D3D"];

// Loop through all the cards and apply colors
coverflowCards.forEach((card, index) => {
  card.style.backgroundColor = colors[index % colors.length];
});

// // ----- Resources -----
// // load more posts
document.addEventListener("DOMContentLoaded", function () {
  // Handle multiple "Load More" buttons on the page
  var loadMoreButtons = document.querySelectorAll(".load-more-btn");

  loadMoreButtons.forEach(function (button) {
    var tabBlock = button.closest(".tab-items") || button.parentElement;

    if (!tabBlock) return;

    var posts = tabBlock.querySelectorAll(".post-list .blog-post");
    var totalPosts = posts.length;

    // Check if the total number of posts is <= 6 and update the button text accordingly
    if (totalPosts <= 6) {
      button.textContent = "No more posts";
      button.disabled = true;
      button.classList.add("disabled");
    } else {
      button.textContent = "Load More";
    }
  });
});

// Handle tab changes
document.querySelectorAll(".tab-menu .tab-link").forEach(function (tabLink) {
  tabLink.addEventListener("click", function (event) {
    var activeTab = event.target;
    var tabContent = document.querySelectorAll(".tab-content");

    // Hide all tab content
    tabContent.forEach(function (tab) {
      tab.style.display = "none";
    });

    // Show active tab content
    var targetTab = document.querySelector(activeTab.getAttribute("href"));
    targetTab.style.display = "block";

    // Reset the visibility and "Load More" for the active tab
    resetTabPosts(targetTab);
  });
});

// Reset posts when changing tabs
function resetTabPosts(tabBlock) {
  var posts = tabBlock.querySelectorAll(".post-list .blog-post");
  var loadMoreButton = tabBlock.querySelector(".load-more-btn");

  // Hide all posts initially
  posts.forEach(function (post) {
    post.style.display = "none";
  });

  // Reset the "Load More" button text and visibility
  loadMoreButton.textContent = "Load More";
  loadMoreButton.disabled = false;
  loadMoreButton.classList.remove("disabled");
  loadMoreButton.setAttribute("data-visible", "6");

  // Show the first 6 posts of the active tab based on filter
  var selectedPostType = document.getElementById("post-filter-dropdown")
    ? document.getElementById("post-filter-dropdown").value
    : "all";

  var visiblePostsCount = 0;
  posts.forEach(function (post) {
    if (
      selectedPostType === "all" ||
      post.getAttribute("data-post-type") === selectedPostType
    ) {
      if (visiblePostsCount < 6) {
        post.style.display = "grid";
        visiblePostsCount++;
      }
    }
  });
}

// When the "Load More" button is clicked
document.addEventListener("click", function (event) {
  if (event.target && event.target.classList.contains("load-more-btn")) {
    var tabBlock =
      event.target.closest(".tab-items") || event.target.parentElement;

    if (!tabBlock) return;

    var posts = tabBlock.querySelectorAll(".post-list .blog-post");
    var totalPosts = posts.length;

    var visiblePosts = parseInt(event.target.getAttribute("data-visible") || 6);
    var selectedPostType = document.getElementById("post-filter-dropdown")
      ? document.getElementById("post-filter-dropdown").value
      : "all"; // Check if the filter is present

    // Show next 6 posts based on filter
    for (var i = visiblePosts; i < visiblePosts + 6 && i < totalPosts; i++) {
      var post = posts[i];

      // Only show posts that match the filter
      if (
        selectedPostType === "all" ||
        post.getAttribute("data-post-type") === selectedPostType
      ) {
        post.style.display = "grid"; // Show post
        post.classList.add("fade-in"); // Optional fade-in effect
      }
    }

    visiblePosts += 6;
    event.target.setAttribute("data-visible", visiblePosts);

    // Disable the "Load More" button if all posts have been shown
    if (visiblePosts >= totalPosts) {
      event.target.textContent = "No more posts";
      event.target.disabled = true;
      event.target.classList.add("disabled");
    }
  }
});

// Check if the post-filter-dropdown element exists on the page
var filterDropdown = document.getElementById("post-filter-dropdown");

if (filterDropdown) {
  // Add event listener only if the element exists
  filterDropdown.addEventListener("change", function () {
    var selectedPostType = this.value;
    var activeTab = document.querySelector(
      ".tab-content[style='display: block;']"
    ); // Get active tab
    var posts = activeTab.querySelectorAll(".blog-post");

    // Reset all posts visibility first
    posts.forEach(function (post) {
      post.style.display = "none"; // Hide all posts initially
    });

    var visiblePostsCount = 0;
    var totalVisiblePosts = 0; // Track how many posts are visible after filtering

    posts.forEach(function (post) {
      // Check if post matches the filter
      if (
        selectedPostType === "all" ||
        post.getAttribute("data-post-type") === selectedPostType
      ) {
        totalVisiblePosts++; // Increase totalVisiblePosts if it matches the filter
        if (visiblePostsCount < 6) {
          post.style.display = "grid"; // Show first 6 posts
          visiblePostsCount++;
        }
      }
    });

    // Reset the "Load More" button to its initial state
    var loadMoreButton = activeTab.querySelector(".load-more-btn");
    loadMoreButton.textContent = "Load More";
    loadMoreButton.disabled = false;
    loadMoreButton.classList.remove("disabled");
    loadMoreButton.setAttribute("data-visible", "6"); // Reset data-visible to 6 when filter is applied

    // Handle "No more posts" condition based on filtered post count
    if (totalVisiblePosts <= 6) {
      loadMoreButton.textContent = "No more posts";
      loadMoreButton.disabled = true;
      loadMoreButton.classList.add("disabled");
    }
  });
}

// scroll bar

document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll(".scroll-container-wrap");
  const progressBars = document.querySelectorAll(".scroll-progress-bar");

  containers.forEach((container, index) => {
    const progressBar = progressBars[index];

    if (!container) {
      console.log("Container not found on this page.");
      return;
    }

    container.addEventListener("scroll", () => {
      const scrollWidth = container.scrollWidth - container.clientWidth;
      const scrollLeft = container.scrollLeft;
      const progress = (scrollLeft / scrollWidth) * 100;
      if (progressBar) {
        progressBar.style.width = progress + "%";
      }
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    const postButton = document.querySelector(".all-post-btn");
    if (postButton) {
      postButton.classList.remove("secondary-btn");
      postButton.style.textDecoration = "underline";
    }
  }
});
// // ----- Our offering -----

// Header dropdown
//
// Trigger classes are set per nav <li> in WP Admin › Appearance › Menus › CSS classes:
//   "header-dropdown-parent"     → opens menuWraps[0] (.dropdown-panel-offerings)
//   "header-dropdown-parent-two" → opens menuWraps[1] (.dropdown-panel-resources)
//
// Data sources (ACF Options):
//   Panel 1 (.dropdown-panel-offerings) pulls from the 'resources' repeater
//   Panel 2 (.dropdown-panel-resources) pulls from the 'resources_dropdown' repeater

function initDropdownHover() {
  if (window.innerWidth > 767) {
    // Nav <li> that opens the Offerings panel
    const headerDropdown = document.querySelector(".header-dropdown-parent");
    // Nav <li> that opens the Resources panel
    const headerDropdownTwo = document.querySelector(
      ".header-dropdown-parent-two"
    );
    const menuWraps = document.querySelectorAll(".products_menu_wrap");
    const headerColorChange = document.querySelector(
      "header .header-container"
    );
    const headerLinksColorChange = document.querySelectorAll(
      ".header-menu-container nav ul li a"
    );

    let closeTimeout; // Variable to hold timeout reference

    if (headerDropdown && menuWraps.length > 0) {
      function addHoverStyles(menu) {
        clearTimeout(closeTimeout); // Cancel closing if user hovers back quickly

        menuWraps.forEach((wrap) =>
          wrap.classList.remove("products_menu_wrap-open")
        );

        // any page: the open panel is white, so the logo must go brand teal
        // (.color-fill is fill:#2a848b !important — beats the tone system)
        const colorFill = document.querySelectorAll(
          "header .header-logo-container-main svg g .logo-letter"
        );

        menu.classList.add("products_menu_wrap-open");

        // Loop through NodeList to add class
        colorFill.forEach((element) => element.classList.add("color-fill"));

        headerColorChange.classList.add("header-bg-change");

        headerLinksColorChange.forEach((link) =>
          link.classList.add("header-color-change")
        );
      }

      function removeHoverStyles(event) {
        const isInsideMenu = [...menuWraps].some((menuWrap) =>
          menuWrap.contains(event.relatedTarget)
        );

        if (isInsideMenu) return;

        closeTimeout = setTimeout(() => {
          menuWraps.forEach((menuWrap) =>
            menuWrap.classList.remove("products_menu_wrap-open")
          );
          headerColorChange.classList.remove("header-bg-change");

          headerLinksColorChange.forEach((link) =>
            link.classList.remove("header-color-change")
          );

          // Remove "color-fill" class when hovering out (same generic
          // selector as addHoverStyles — the tone system takes back over)
          const colorFill = document.querySelectorAll(
            "header .header-logo-container-main svg g .logo-letter"
          );

          colorFill.forEach((element) =>
            element.classList.remove("color-fill")
          );
        }, 200);
      }

      menuWraps.forEach((menuWrap) => {
        menuWrap.addEventListener("mouseleave", removeHoverStyles);
        menuWrap.addEventListener("mouseenter", () =>
          clearTimeout(closeTimeout)
        );
      });

      headerDropdown.addEventListener("mouseenter", function () {
        addHoverStyles(menuWraps[0]);
      });

      headerDropdownTwo.addEventListener("mouseenter", function () {
        addHoverStyles(menuWraps[1]);
      });

      headerDropdown.addEventListener("mouseleave", removeHoverStyles);
      headerDropdownTwo.addEventListener("mouseleave", removeHoverStyles);
    }
  }
}

document.addEventListener("DOMContentLoaded", initDropdownHover);

// Re-run on resize
window.addEventListener("resize", () => {
  document.querySelectorAll(".products_menu_wrap-open").forEach((menu) => {
    menu.classList.remove("products_menu_wrap-open");
  });

  if (window.innerWidth <= 767) {
    return; // Stop running the script if below threshold
  }

  initDropdownHover();
});

// our people animation

document.addEventListener("DOMContentLoaded", function () {
  const peopleCards = document.querySelectorAll(".people-card");
  const closeButtons = document.querySelectorAll(".close-content");

  peopleCards.forEach((card) => {
    card.addEventListener("click", function () {
      const targetId = this.getAttribute("data-target");
      const content = document.getElementById(targetId);
      if (content) {
        content.classList.add("active");
        document.body.style.overflow = "hidden"; // Stop body scroll
      }
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const contentContainer = this.closest(".people-card-content-container");
      if (contentContainer) {
        contentContainer.classList.remove("active");
        document.body.style.overflow = ""; // Re-enable body scroll
      }
    });
  });
});

// ----- svgartista animation ----- //

// Function to handle intersection changes
function handleIntersection(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // Add your animation class here
      entry.target.classList.add("active");

      // Once animation is applied, you may want to disconnect the observer
      observer.unobserve(entry.target);
    }
  });
}
// Create a new intersection observer
const observer = new IntersectionObserver(handleIntersection, {
  root: null, // viewport
  rootMargin: "0px", // no margin
  threshold: 0.5, // 50% of the element visible
});

// Select the elements you want to observe
const elementsToObserve = document.querySelectorAll(".svganimate");

// Start observing each element
elementsToObserve.forEach((element) => {
  observer.observe(element);
});

// ----- svgartista animation ----- //

// people advisory
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".banner-image-pa")) {
    let tl = gsap.timeline();
    tl.to(["#left1", "#right1"], { strokeDashoffset: 0, duration: 0.8 })
      .to(["#left2", "#right2"], { strokeDashoffset: 0, duration: 0.8 })
      .to(["#left3", "#right3"], { strokeDashoffset: 0, duration: 0.8 })
      .to("#center", { strokeDashoffset: 0, duration: 0.8 });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const swiper = new Swiper(".productSwiper", {
    loop: true,
    centeredSlides: true,
    spaceBetween: 15,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next-product",
      prevEl: ".swiper-button-prev-product",
    },
    breakpoints: {
      320: {
        // For mobile screens
        slidesPerView: 1,
        centeredSlides: false,
      },
      768: {
        // For tablets and above
        slidesPerView: 1.5,
        centeredSlides: true,
      },
    },
  });
});

// pop up

document.addEventListener("DOMContentLoaded", () => {
  const popupLinks = document.querySelectorAll(".popup-video");
  const popup = document.createElement("div");
  popup.className = "video-popup";
  popup.innerHTML = `
        <div class="video-popup-content">
            <span class="close-popup">&times;</span>
            <iframe id="video-frame" width="560" height="315" src="" frameborder="0" allowfullscreen></iframe>
        </div>
    `;
  document.body.appendChild(popup);

  const closePopup = popup.querySelector(".close-popup");
  const videoFrame = popup.querySelector("#video-frame");

  popupLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const videoUrl = link.getAttribute("href").replace("watch?v=", "embed/");
      videoFrame.src = videoUrl;
      popup.style.display = "block";
    });
  });

  closePopup.addEventListener("click", () => {
    popup.style.display = "none";
    videoFrame.src = "";
  });

  // Close on click outside the popup content
  popup.addEventListener("click", (e) => {
    if (e.target === popup) {
      popup.style.display = "none";
      videoFrame.src = "";
    }
  });
});

// copy message
document.addEventListener("DOMContentLoaded", () => {
  const copyLinks = document.querySelectorAll(".copy-link");
  const copyMessage = document.getElementById("copyMessage");

  copyLinks.forEach((copyLink) => {
    copyLink.addEventListener("click", (e) => {
      e.preventDefault();
      const pageUrl = window.location.href;

      navigator.clipboard
        .writeText(pageUrl)
        .then(() => {
          copyMessage.style.opacity = "1";
          copyMessage.style.visibility = "visible";

          setTimeout(() => {
            copyMessage.style.opacity = "0";
            copyMessage.style.visibility = "hidden";
          }, 1500); // Hide after 1.5 seconds
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    });
  });
});

// post btn
document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.querySelector(".load-more-btn-post");
  const allPosts = document.querySelectorAll(".podcast-item.hidden-post");
  const postsPerClick = 6;
  let currentIndex = 0;

  loadMoreBtn.addEventListener("click", function () {
    let shown = 0;

    for (
      let i = currentIndex;
      i < allPosts.length && shown < postsPerClick;
      i++
    ) {
      allPosts[i].classList.remove("hidden-post");
      shown++;
    }

    currentIndex += shown;

    if (currentIndex >= allPosts.length) {
      loadMoreBtn.textContent = "No More Posts";
      loadMoreBtn.disabled = true;
      loadMoreBtn.classList.add("no-more");
    }
  });

  // Hide button if all posts are already shown (e.g. less than or equal to 6)
  if (allPosts.length <= 0) {
    loadMoreBtn.textContent = "No More Posts";
    loadMoreBtn.disabled = true;
    loadMoreBtn.classList.add("no-more");
  }
});

// cards stack animaiton 
document.addEventListener("DOMContentLoaded", function () {
  const cardsStackSec = document.querySelector('.cards-stack-sec');
  if (!cardsStackSec) return;
  (function() {
    const cardsContainer = document.querySelector('.cards');
    const cards = Array.from(document.querySelectorAll('.card'));

    if (cards.length === 0) return;

    // Set CSS vars for grid
    cardsContainer.style.setProperty('--cards-count', cards.length);
    cardsContainer.style.setProperty('--card-height', `${cards[0].clientHeight}px`);

    // Set initial padding for offset (mobile = 50, desktop = 150)
    cards.forEach((card, index) => {
      const baseOffset = window.innerWidth <= 600 ? 50 : 150;
      const offsetTop = baseOffset + index * 20;
      card.style.paddingTop = `${offsetTop}px`;
    });

    // Function to get percentage progress for an element
    function getProgressY(element) {
      const rect = element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;

      const elementTop = rect.top + scrollTop;
      const elementBottom = elementTop + element.clientHeight;

      const offsetTop = 20; // matches the padding
      const adjustedTop = elementTop - offsetTop;
      const adjustedBottom = elementBottom - offsetTop - windowHeight + element.clientHeight;

      if (scrollTop < adjustedTop) return 0;
      if (scrollTop > adjustedBottom) return 1;
      return (scrollTop - adjustedTop) / (adjustedBottom - adjustedTop);
    }

    // For each card except the last
    cards.slice(0, -1).forEach((card, index) => {
      const nextCard = cards[index + 1];
      const cardInner = card.querySelector('.card__inner');

      const toScale = 1 - (cards.length - 1 - index) * 0.1;

      function update() {
        const percentageY = getProgressY(nextCard);
        const scale = 1 + (toScale - 1) * percentageY;
        const brightness = 1 + (0.6 - 1) * percentageY;

        cardInner.style.transform = `scale(${scale})`;
        cardInner.style.filter = `brightness(${brightness})`;
      }

      // Initial update
      update();

      // Listen to scroll
      window.addEventListener('scroll', update, { passive: true });
    });

    // Resize handler
    window.addEventListener('resize', () => {
      cardsContainer.style.setProperty('--card-height', `${cards[0].clientHeight}px`);
      cards.forEach((card, index) => {
        const baseOffset = window.innerWidth <= 600 ? 50 : 150;
        const offsetTop = baseOffset + index * 20;
        card.style.paddingTop = `${offsetTop}px`;
      });
    });
  })();
});

// cards inner animation 
document.addEventListener("DOMContentLoaded", function () {
  const block = document.querySelector(".hand-animation");
  if (!block) return;

  gsap.registerPlugin(ScrollTrigger);

  // Start visible. The reveal used to gsap.set opacity:0 and fade back in via
  // the ScrollTrigger below, but on the sticky cards-stack deck that trigger
  // doesn't reliably fire, leaving the Talent hands stuck invisible. Keeping
  // them visible guarantees they render; the slide-in still plays if the
  // trigger fires.
  gsap.set(".hand-one, .hand-two, .hand-three, .hand-four, .hand-five, .hand-six, .hand-seven", {
    opacity: 1
  });

  ScrollTrigger.create({
    trigger: block,
    start: "top bottom",
    once: true,
    onEnter: () => animateHands()
  });

  function animateHands() {
    const tl = gsap.timeline();

    tl
      .to(".hand-one", {
        opacity: 1,
        top: 0,
        duration: 0.8,
        ease: "power2.out"
      }, 0)

      .to(".hand-two", {
        opacity: 1,
        top: 0,
        left: 0,
        duration: 0.8,
        ease: "power2.out"
      }, 0.1)

      .to(".hand-three", {
        opacity: 1,
        right: 0,
        duration: 0.8,
        ease: "power2.out"
      }, 0.2)

      .to(".hand-four", {
        opacity: 1,
        top: 0,
        right: 0,
        duration: 0.8,
        ease: "power2.out"
      }, 0.3)

      .to(".hand-five", {
        opacity: 1,
        bottom: 0,
        right: 0,
        duration: 0.8,
        ease: "power2.out"
      }, 0.4)

      .to(".hand-seven", {
        opacity: 1,
        left: 0,
        bottom: 60,
        duration: 1,
        ease: "power2.out"
      }, 0.5)

      .to(".hand-six", {
        opacity: 1,
        bottom: 0,
        duration: 0.8,
        ease: "power2.out"
      }, 0.6);
  }
});

// svg artista 
document.addEventListener("DOMContentLoaded", () => {
  function observeElements(selector, activeClass = "active") {
    const elements = document.querySelectorAll(selector);
  
    if (!elements.length) return;
  
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(activeClass);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1, // Adjust as needed, triggers when 10% visible
    });
  
    elements.forEach(el => observer.observe(el));
  }
  
  // Usage example: observe all elements with class ".svgartista" and add "active" class when visible
  observeElements(".svgartista", "active");
});

// youtube video resources
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.video-thumbnail[data-youtube-url]').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const youtubeUrl = this.getAttribute('data-youtube-url');
      if (!youtubeUrl) return;

      // Extract the YouTube video ID from the URL
      const videoId = youtubeUrl.split('v=')[1] || youtubeUrl.split('youtu.be/')[1];
      if (!videoId) return;

      // Clean videoId from any additional params (like &t= or &list=)
      const ampersandPosition = videoId.indexOf('&');
      const cleanVideoId = ampersandPosition !== -1 ? videoId.substring(0, ampersandPosition) : videoId;

      // Build iframe embed
      const iframe = document.createElement('iframe');
      iframe.setAttribute('width', '100%');
      iframe.setAttribute('height', '315');
      iframe.setAttribute('src', `https://www.youtube.com/embed/${cleanVideoId}?autoplay=1&rel=0`);
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', 'true');

      // Replace thumbnail div content with iframe
      this.innerHTML = '';
      this.appendChild(iframe);
      this.style.cursor = 'default';
    });
  });
});
// ── who-we-are: Our People tabs + profile drawer ────────────────────────────
// Ported from the "Who We Are - Teams" reference draft. Both panels stay in
// the DOM (the switch only hides one); the drawer is a single instance filled
// from the clicked card's data attributes + hidden bio markup.
document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector(".wwa-people");
  if (!root) return;

  // the two-way panel switch
  const tabs = Array.from(root.querySelectorAll(".wwa-ppl-tab"));
  const panels = Array.from(root.querySelectorAll(".wwa-ppl-panel"));
  function selectTab(i, focusIt) {
    tabs.forEach(function (t, n) {
      const on = n === i;
      t.setAttribute("aria-selected", on ? "true" : "false");
      t.tabIndex = on ? 0 : -1;
      if (panels[n]) panels[n].hidden = !on;
    });
    if (focusIt) tabs[i].focus();
  }
  tabs.forEach(function (t, i) {
    t.addEventListener("click", function () {
      selectTab(i, false);
    });
    t.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight" || e.key === "ArrowDown") {
        e.preventDefault();
        selectTab((i + 1) % tabs.length, true);
      }
      if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
        e.preventDefault();
        selectTab((i + tabs.length - 1) % tabs.length, true);
      }
      if (e.key === "Home") {
        e.preventDefault();
        selectTab(0, true);
      }
      if (e.key === "End") {
        e.preventDefault();
        selectTab(tabs.length - 1, true);
      }
    });
  });

  // the profile drawer: open from a card, close via X, Escape or the veil.
  // Focus goes in and comes back; Tab is kept inside while it is open.
  const drawer = document.getElementById("wwaDrawer");
  const veil = document.getElementById("wwaDrVeil");
  if (!drawer || !veil) return;
  const drX = document.getElementById("wwaDrX");
  const drScroll = document.getElementById("wwaDrScroll");
  const drShot = document.getElementById("wwaDrShot");
  const drImg = document.getElementById("wwaDrImg");
  const drName = document.getElementById("wwaDrName");
  const drRole = document.getElementById("wwaDrRole");
  const drKind = document.getElementById("wwaDrKind");
  const drLi = document.getElementById("wwaDrLi");
  const drBio = document.getElementById("wwaDrBio");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let lastFocus = null;
  let drawerOn = false;

  function openProfile(card, trigger) {
    lastFocus = trigger || null;

    drKind.textContent = card.dataset.kind || "Profile";
    drName.textContent = card.dataset.name || "";
    drRole.textContent = card.dataset.role || "";
    if (card.dataset.img) {
      drImg.src = card.dataset.img;
      drImg.alt = card.dataset.name || "";
      drShot.hidden = false;
    } else {
      drShot.hidden = true;
    }
    if (card.dataset.li) {
      drLi.href = card.dataset.li;
      drLi.hidden = false;
    } else {
      drLi.hidden = true;
    }
    const pc = getComputedStyle(card).getPropertyValue("--pc").trim();
    drawer.style.setProperty("--dc", pc || "");
    const bio = card.querySelector(".wwa-person-bio");
    drBio.innerHTML = bio ? bio.innerHTML : "";
    drScroll.scrollTop = 0;

    drawer.hidden = false;
    veil.hidden = false;
    // one frame, so the transform has a state to move away from
    window.requestAnimationFrame(function () {
      drawer.classList.add("is-on");
      veil.classList.add("is-on");
    });
    document.body.classList.add("wwa-locked");
    drawerOn = true;
    drX.focus();
  }

  function closeProfile() {
    if (!drawerOn) return;
    drawerOn = false;
    drawer.classList.remove("is-on");
    veil.classList.remove("is-on");
    document.body.classList.remove("wwa-locked");
    const done = function () {
      drawer.hidden = true;
      veil.hidden = true;
    };
    if (reduceMotion) done();
    else window.setTimeout(done, 520);
    if (lastFocus) lastFocus.focus();
    lastFocus = null;
  }

  root.querySelectorAll("[data-wwa-person]").forEach(function (card) {
    const btn = card.querySelector(".wwa-person-more");
    if (btn) {
      btn.addEventListener("click", function () {
        openProfile(card, btn);
      });
    }
  });

  drX.addEventListener("click", closeProfile);
  veil.addEventListener("click", closeProfile);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawerOn) {
      closeProfile();
      return;
    }
    // keep Tab inside the drawer while it is the thing on screen
    if (e.key !== "Tab" || !drawerOn) return;
    const f = Array.from(
      drawer.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) {
      return !el.hidden && el.offsetParent !== null;
    });
    if (!f.length) return;
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
});

// ── who-we-are: podcast carousel (ported from the SaaStr landing page) ──────
document.addEventListener("DOMContentLoaded", function () {
  const track = document.getElementById("wwaPodTrack");
  const prevBtn = document.getElementById("wwaPodPrev");
  const nextBtn = document.getElementById("wwaPodNext");
  if (!track || !prevBtn || !nextBtn) return;

  const cards = track.querySelectorAll(".wwa-pod__card");
  if (!cards.length) return;

  let current = 0;
  const total = cards.length;

  function visibleCount() {
    const w = window.innerWidth;
    if (w <= 580) return 1;
    if (w <= 900) return 2;
    return 3;
  }
  function cardWidth() {
    return cards[0].getBoundingClientRect().width + 20;
  }
  function maxIndex() {
    return Math.max(0, total - visibleCount());
  }
  function apply() {
    track.style.transform = "translateX(-" + current * cardWidth() + "px)";
    prevBtn.disabled = current === 0;
    nextBtn.disabled = current >= maxIndex();
  }

  prevBtn.addEventListener("click", function () {
    if (current > 0) {
      current--;
      apply();
    }
    resetTimer();
  });
  nextBtn.addEventListener("click", function () {
    if (current < maxIndex()) {
      current++;
      apply();
    }
    resetTimer();
  });

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      current = Math.min(current, maxIndex());
      apply();
    }, 80);
  });

  apply();

  // autoplay: advance every 5s, wraps; pauses on hover/focus
  let timer = null;
  const wrap = document.querySelector(".wwa-pod__slider-wrap");
  function advance() {
    current = current >= maxIndex() ? 0 : current + 1;
    apply();
  }
  function startTimer() {
    timer = setInterval(advance, 5000);
  }
  function resetTimer() {
    clearInterval(timer);
    startTimer();
  }
  if (wrap) {
    wrap.addEventListener("mouseenter", function () {
      clearInterval(timer);
    });
    wrap.addEventListener("mouseleave", startTimer);
    wrap.addEventListener("focusin", function () {
      clearInterval(timer);
    });
    wrap.addEventListener("focusout", startTimer);
  }
  startTimer();
});

// ── who-we-are: newsletter form ─────────────────────────────────────────────
// Validates the address; posts natively to the Mailchimp action when one is
// configured, otherwise reports the form as not connected yet.
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("wwaNewsForm");
  if (!form) return;
  const input = document.getElementById("wwaNewsEmail");
  const note = document.getElementById("wwaNewsNote");
  const baseNote = note.textContent;

  form.addEventListener("submit", function (e) {
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
    input.setAttribute("aria-invalid", ok ? "false" : "true");
    if (!ok) {
      e.preventDefault();
      note.classList.add("is-err");
      note.textContent = "That address does not look right. Check it and try again.";
      input.focus();
      return;
    }
    if (!form.getAttribute("action")) {
      e.preventDefault();
      note.classList.add("is-err");
      note.textContent = "Not connected yet. Point this form at the mailing list to go live.";
      return;
    }
    note.classList.remove("is-err");
    note.textContent = baseNote;
  });
});
